export const REFRESH_ANNOTATIONS = 'REFRESH_ANNOTATIONS';
export const UPDATE_ANNOTATIONS = 'UPDATE_ANNOTATIONS';

export const refreshAnnotations = derivedsetId => {
  return { type: REFRESH_ANNOTATIONS, payload: derivedsetId };
};

export const updateAnnotations = data => {
  return { type: UPDATE_ANNOTATIONS, payload: data };
};